import { hMacAjax } from 'grt-tool-lib-front';
import { baseURL } from '@/httpService/API';
// const baseUserURL = `${baseURL}/grt-user-service`;
const baseCenterURL = `${baseURL}/grt-user-center-service`;

//章节列表-学员
export const getProjectChapterList = (data) => {
    return hMacAjax.post(baseCenterURL + '/user/teaching-item/course/chapter', data);
};

//项目课程简介
export const getProjectCourseDes = (id) => {
    return hMacAjax.get(baseCenterURL + '/user/teaching-item/course/' + id);
};
//获取文档打开状态
export const setDocumentStatus = (data) => {
    return hMacAjax.post(baseCenterURL + '/user/teaching-item/course/document/', data);
};
//查询项目配置--防作弊
export const getProjectConfig = (data) => {
    return hMacAjax.get(baseCenterURL + '/user/business/config/detail/', data);
};
// 上一个/下一个课程
export const adjacentCourese = (data) => {
    return hMacAjax.post(baseCenterURL + '/user/integration-project/v1/front/after/course', data);
};
